export default {
  data() {
    return {
      sortDesc: null,
      sortBy: null,
    };
  },
  methods: {
    eventSortBy(e) {
      this.sortBy = e.length ? e[0] : null;
      this.fetchSortCommon();
    },
    eventSortDesc(e) {
      this.sortDesc = e.length ? e[0] : null;
      this.fetchSortCommon();
    },
    fetchSortCommon() {
      const sortUrl = `${this.sortName(this.sortBy)}:${
        this.sortDesc ? "desc" : "asc"
      }`;
      if (this.sortBy !== null && this.sortDesc !== null) {
        this.clearCommonModule();
        this.sortCommon = sortUrl;
        this.fetchCommonModule(this.getCompleteUrl(sortUrl), true);
      } else {
        this.clearCommonModule();
        this.sortCommon = null;
        const payload = "?response=lite&page=1";
        this.fetchCommonModule(payload, true);
      }
    },
    getCompleteUrl(sortUrl) {
      return `?response=lite&page=1${this.filterData}&sort=${sortUrl}`;
    },
    sortName(name) {
      if (name === "type.label") {
        return "type";
      } else if (name === "project.label") {
        return "project";
      } else if (name === "situation.label") {
        return "situation";
      }
      return name;
    },
  },
};
